import React from 'react';
import {useAuthService} from '../../provider/AuthProvider';

const Logout = () => {
    const authService = useAuthService();
    authService.signoutRedirect();
    return <span/>;
};

export default Logout;